/* eslint-disable sonarjs/no-duplicate-string */
import { type Signal, useSignal } from '@preact/signals-react'
import { notification } from 'antd'

import { EApplicationType } from '@/interfaces'
import { FormState } from '@/state'
import { applicationsStateActions } from '@/state/actions'

interface ConvocatoriaResult {
  loading: Signal<{
    improve: boolean
    ruralLiving: boolean
    urbanLiving: boolean
  }>
  newRuralLivingApplication: () => void
  newUpgradeApplication: () => void
  newUrbanLivingApplication: () => void
}
export const useConvocatoria = (): ConvocatoriaResult => {
  const loading = useSignal({
    improve: false,
    ruralLiving: false,
    urbanLiving: false,
  })

  const newUrbanLivingApplication = (): void => {
    loading.value = {
      ...loading.peek(),
      urbanLiving: true,
    }
    applicationsStateActions
      .createNewApplication(EApplicationType.URBAN_LIVING)
      .then(() => {
        if (FormState.showForm.peek()) {
          notification.success({
            description:
              'Se ha generado una nueva solicitud de vivienda urbana',
            message: 'Solicitud generada',
            placement: 'top',
          })
        }
      })
      .catch((_) =>
        notification.error({
          message: 'Error generando la solicitud',
          placement: 'top',
        })
      )
      .finally(() => {
        loading.value = {
          ...loading.peek(),
          urbanLiving: false,
        }
      })
  }
  const newRuralLivingApplication = (): void => {
    loading.value = {
      ...loading.peek(),
      ruralLiving: true,
    }
    applicationsStateActions
      .createNewApplication(EApplicationType.RURAL_LIVING)
      .then(() => {
        if (FormState.showForm.peek()) {
          notification.success({
            description: 'Se ha generado una nueva solicitud de vivienda rural',
            message: 'Solicitud generada',
            placement: 'top',
          })
        }
      })
      .catch((_) =>
        notification.error({
          message: 'Error generando la solicitud',
          placement: 'top',
        })
      )
      .finally(() => {
        loading.value = {
          ...loading.peek(),
          ruralLiving: false,
        }
      })
  }

  const newUpgradeApplication = (): void => {
    loading.value = {
      ...loading.peek(),
      improve: true,
    }
    applicationsStateActions
      .createNewApplication(EApplicationType.IMPROVEMENT)
      .then(() =>
        notification.success({
          description: 'Se ha generado una nueva solicitud de mejota',
          message: 'Solicitud generada',
          placement: 'top',
        })
      )
      .catch((_) =>
        notification.error({
          message: 'Error generando la solicitud',
          placement: 'top',
        })
      )
      .finally(() => {
        loading.value = {
          ...loading.peek(),
          improve: false,
        }
      })
  }

  return {
    loading,
    newRuralLivingApplication,
    newUpgradeApplication,
    newUrbanLivingApplication,
  }
}
